export const BREAKPOINTS = {
    'mobile': 1023
}

export const BROWSER_DETECT = {
    isChrome   : navigator.userAgent.indexOf('Chrome') > -1,
    isExplorer : navigator.userAgent.indexOf('MSIE') > -1,
    isFirefox  : navigator.userAgent.indexOf('Firefox') > -1,
    isSafari   : navigator.userAgent.indexOf("Safari") > -1
}